import httpClient from "../http/http-client";
import { IEnergySupplier } from './energy-supplier.model';

export default class EnergySupplierService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAll(): Promise<IEnergySupplier[]> {
    return this.http.get('energy-supplier')
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        throw err
      });
  }

  async getAllWithPagination(searchQuery: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc'): Promise<{ count: number, rows: IEnergySupplier[] }> {
    return this.http.get(`energy-supplier?nameIncludes=${searchQuery}&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async getOne(energySupplierId: string): Promise<IEnergySupplier> {
    return this.http.get(`energy-supplier/${energySupplierId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async create(energySupplier: Partial<IEnergySupplier>): Promise<IEnergySupplier> {
    return this.http.post('energy-supplier', energySupplier)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async edit(energySupplierId: string, energySupplier: Partial<IEnergySupplier>): Promise<IEnergySupplier> {
    return this.http.patch(`energy-supplier/${energySupplierId}`, energySupplier)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }
}


